import { render, staticRenderFns } from "./success.vue?vue&type=template&id=994d692c&scoped=true&"
import script from "./success.vue?vue&type=script&lang=ts&"
export * from "./success.vue?vue&type=script&lang=ts&"
import style0 from "./success.vue?vue&type=style&index=0&id=994d692c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d692c",
  null
  
)

export default component.exports